// Firebase Configuration
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBOfDvKvLoe5rxthelmb0qGCShnqDWMi6M",
    authDomain: "toolshub-b774b.firebaseapp.com",
    projectId: "toolshub-b774b",
    storageBucket: "toolshub-b774b.firebasestorage.app",
    messagingSenderId: "441312198253",
    appId: "1:441312198253:web:49c7c217b1ad1fdaf78964",
    measurementId: "G-WBWVF9TC71"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";

// Initialize services
export const auth = getAuth(app);

// Use persistent cache for Firestore (helps with data persistence and performance)
// initializeFirestore must be called BEFORE getFirestore if using custom options, 
// or just use it as the primary initialization.
export const db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

export const storage = getStorage(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

// Auth Providers
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');

export default app;
